<template>
  <div class="give-right">
    <a-row :gutter="8">
      <a-col :span="4">
        <a-input
          placeholder="请输入学生姓名"
          allow-clear
          v-model="searchParams.studentName"
        />
      </a-col>
      <a-col :span="4">
        <a-input
          placeholder="请输入学生手机号"
          allow-clear
          v-model="searchParams.phoneNumber"
        />
      </a-col>
      <a-col :span="4">
        <div class="right-select">
          <span class="filter-selection">权益类型</span>
          <a-select
            placeholder="权益类型"
            style="width: calc(100% - 68px);margin-left: 8px;"
            v-model="jurisdiction"
          >
            <a-select-option
              :value="item.id"
              v-for="item in getJurisdictionType"
              :key="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </a-col>
      <a-col :span="6">
        <a-button type="primary" @click="search" style="margin-right: 8px;">
          搜索
        </a-button>
        <a-button @click="reset" class="ant-btn-secondary">
          重置
        </a-button>
      </a-col>
      <a-col :span="6" style="text-align:right;">
        <a-button type="primary" @click="newStu">
          添加新学员
        </a-button>
      </a-col>
    </a-row>
    <div style="margin: 16px 0 21px 0;" class="num-title">
      <span class="try-num">机构剩余体验权益名额：{{ tryNum }}</span>
      <span class="all-num">
        机构剩余小初全科权益名额：{{ allNum }}
        <a-tooltip placement="bottom">
          <template slot="title">
            <p>已过期名额：</p>
            <p>一年有效：{{ expireNum.aYear }}</p>
            <p>三年有效：{{ expireNum.threeYears }}</p>
            <p>永久有效：{{ expireNum.forever }}</p>
          </template>
          <a-icon type="exclamation-circle" style="color: #767D91;padding-top: 4px;cursor: pointer;" />
        </a-tooltip>
        <span style="marginLeft: 10px;color: #FF8800;" v-if="expireNum.aYearExpire || expireNum.threeYearsExpire || expireNum.foreverExpire">
          <span class="expiring-soon-tip" v-if="expireNum.aYearExpire">近30天一年有效：{{ expireNum.aYearExpire }}个权益即将过期</span>
          <span class="expiring-soon-tip" v-if="expireNum.threeYearsExpire">近30天三年有效：{{ expireNum.threeYearsExpire }}个权益即将过期</span>
          <span class="expiring-soon-tip" v-if="expireNum.foreverExpire">近30天永久有效：{{ expireNum.foreverExpire }}个权益即将过期</span>
        </span>
      </span>
    </div>
    <div class="table-wrap">
      <a-table
        class="table"
        row-key="id"
        :scroll="scroll"
        :loading="tableLoading"
        :columns="columns"
        :data-source="studentList"
        :pagination="false"
      >
        <div slot="userName" slot-scope="text">
          <span>{{ text || '--' }}</span>
        </div>

        <div slot="jurisdiction" slot-scope="text, row">
          <!-- 状态:0 无权益,1:体验权益，2:全科权益	 -->
          <div class="jurisdiction">
            <span :style="{color: getRightColor(text)}">
              {{ getRightTxt(text) }}
            </span>
            <p class="right-time" v-if="text === 1">
              {{ $moment(row.endTime).format('YYYY.MM.DD') }}  (剩余{{ row.experienceDays }}天)
            </p>
          </div>
        </div>
        <div slot="origin" slot-scope="text">
          {{ text === 'xkhTeacher' ? '小括狐教师端' : "--" }}
        </div>
        <span slot="courseNameStringList" slot-scope="text, row" style="display: flex;">
          <!-- <a-tooltip v-if="text && text.length > 0" :title="text[0]" placement="topRight">
            <span class="course-name">{{ text[0] }}</span>
          </a-tooltip> -->
          <p v-if="text && text.length > 0" :title="text[0]" class="course-name">{{ text[0] }}</p>
          <span v-else>{{ '--' }}</span>
          <!-- 课程大于0时 -->
          <a-tooltip
            v-if="row.courseCount > 1"
            placement="rightTop"
            trigger="click"
            @click="(e) => { e.stopPropagation();}"
          >
            <template slot="title" v-if="text">
              <ul v-for="(courseName, idx) in text" :key="idx">
                <li v-show="idx < 5">{{ courseName }}</li>
              </ul>
              <p v-show="text.length > 5">...</p>
            </template>
            <!-- 计数 -->
            <div style="width: 30px;">
              <a-badge
                :count="row.courseCount"
                :number-style="{
                  backgroundColor: '#fff',
                  color: '#999',
                  boxShadow: '0 0 0 1px #d9d9d9 inset',
                  cursor: 'pointer',
                  'margin-left': '6px'
                }"
              />
            </div>
          </a-tooltip>
        </span>
        <div slot="action" slot-scope="text, row">
          <RightAction @updList="updList" :stu-info="row" />
        </div>
      </a-table>
    </div>
    <div class="pagination">
      <a-pagination
        v-show="pagination.total > 0"
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>
    <create-student
      v-if="createStudentVisible"
      :visible.sync="createStudentVisible"
      @addStudentSuccess="getList"
    />
  </div>
</template>

<script>
import columns from './columns'
import CreateStudent from '@/components/createStudent/index.vue'
import RightAction from './RightAction.vue'
import { RIGHT_MAP } from './constant'
import { mapGetters } from 'vuex'

export default {
  name: 'GiveRight',

  components: {
    CreateStudent,
    RightAction
  },

  data() {
    return {
      tryNum: '',
      allNum: '',
      expireNum: {
        aYear: 0,
        aYearExpire: 0,
        threeYears: 0,
        threeYearsExpire: 0,
        forever: 0,
        foreverExpire: 0
      },
      RIGHT_MAP,
      scroll: { y: 'calc(100vh - 370px)' },
      columns,
      studentList: [],
      createStudentVisible: false,
      tableLoading: false,
      jurisdiction: -1,
      searchParams: {
        studentName: undefined,
        phoneNumber: undefined
      },
      pagination: {
        pageSize: 20,
        total: 0,
        current: 1
      }
    }
  },

  created() {
    this.getRemainCount()
    this.getList()
  },

  computed: {
    ...mapGetters({
      jurisdictionType: 'common/jurisdictionType'
    }),
    getJurisdictionType () {
      return [
        {
          name: '全部',
          id: -1
        },
        ...this.jurisdictionType
      ]
    }
  },

  methods: {
    updList() {
      this.getRemainCount()
      this.getList()
    },
    async getRemainCount() { // 获取剩余名额
      const result = await this.$service.studentRight.insQuota({
        cardType: [10, 13, 14, 15, 1000]
      })
      if (Array.isArray(result)) {
        result.forEach(k => {
          if (k.cardType === 10) this.tryNum = k.residueNumber
          if (k.cardType === 1000) this.allNum = k.residueNumber
          if (k.cardType === 13) {
            this.expireNum.aYear = k.expireNumber
            this.expireNum.aYearExpire = k.expiringSoonTip
          }
          if (k.cardType === 14) {
            this.expireNum.threeYears = k.expireNumber
            this.expireNum.threeYearsExpire = k.expiringSoonTip
          }
          if (k.cardType === 15) {
            this.expireNum.forever = k.expireNumber
            this.expireNum.foreverExpire = k.expiringSoonTip
          }
        })
      }
    },

    getRightColor(num) {
      if (!num && num !== 0) return ''
      return RIGHT_MAP[num].color || ''
    },

    getRightTxt(num) {
      if (!num && num !== 0) return '--'
      return RIGHT_MAP[num].name || '--'
    },

    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },

    // 获取学员列表
    async getList() {
      this.tableLoading = true
      const searchParams = {
        ...this.searchParams,
        jurisdiction: this.jurisdiction >= 0 ? this.jurisdiction : -1,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.$service.studentRight.getStudentList(searchParams).then(res => {
        this.loading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        this.studentList = res.list || []
        console.log(this.studentList)
      }).finally(() => {
        this.tableLoading = false
      })
    },

    search() {
      this.pagination.current = 1
      this.getRemainCount()
      this.getList()
    },

    reset() {
      Object.keys(this.searchParams).forEach(k => {
        this.searchParams[k] = undefined
      })
      this.jurisdiction = -1
      this.pagination.current = 1
      this.getRemainCount()
      this.getList()
    },

    newStu() {
      this.createStudentVisible = true
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
// :deep(.ant-table-body) {
//   padding-right: 12px;
// }
.give-right {
    height: 100%;
    width: 100%;
    .table-wrap {
      height: calc(100% - 160px);
    }
    .right-select {
      display: flex;
      align-items: center;
    }
    .num-title {
      color: #3262FD;
      .all-num {
        margin-left: 20px;
        .expiring-soon-tip {
          margin-left: 10px;
        }
      }
    }
    .course-name {
      display: inline-block;
      // width: 70%;
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
    .pagination {
      height: 30px;
      text-align: right;
      padding-top: 12px;
    }
}
</style>
